import React, { useState } from 'react';
import { Card, Tabs } from 'antd';
import MembershipPackageCrud from './MembershipPackageCrud';
import MemberManager from './MemberManager';
import RenewalManager from './RenewalManager';

const MembershipPackageList = () => {
  const [memberDataVersion, setMemberDataVersion] = useState(0);

  const handleMemberDataChanged = () => {
    setMemberDataVersion((current) => current + 1);
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="Quản trị thành viên">
        <Tabs
          defaultActiveKey="packages"
          items={[
            {
              key: 'packages',
              label: 'Gói thành viên',
              children: <MembershipPackageCrud />
            },
            {
              key: 'members',
              label: 'Thành viên',
              children: <MemberManager key={`members-${memberDataVersion}`} />
            },
            {
              key: 'renewals',
              label: 'Đăng ký & gia hạn',
              children: <RenewalManager onMemberDataChanged={handleMemberDataChanged} />
            }
          ]}
        />
      </Card>
    </div>
  );
};

export default MembershipPackageList;
